import {Ventrata} from 'types'
import {Question} from './Question'

type Props = {
  index: number
  questions: Ventrata.Question[]
  bookingUuid: string
  uinitItemId: string
}

export const TravelerDetails = ({index, questions, bookingUuid, uinitItemId}: Props) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="text-lg font-bold">Traveler {index}</div>

      {questions.map((question) => {
        return <Question key={question.id} bookingUuid={bookingUuid} question={question} unitItemId={uinitItemId} />
      })}
    </div>
  )
}
